<template>
<!--S 代理品牌 -->
  <section class="wraper">
    <div class="container">
      <ul>
        <li v-for="(item,index) of brand" :key="index">
          <img v-if="item.url==null" src="../../../assets/images/index/bard.jpg">
          <img v-else :src="`${$base.urlImage}${item.url}`">
          <div class="bd">
            <p>品牌：{{item.name}}</p>
            <!-- <p>名称：{{item.name}}</p> -->
          </div>
        </li>
      </ul>
      <!-- <paginations :totalPage="totalPage" @prevClick="pageClick" @nextClick="pageClick" @currentChange="pageClick"/> -->
      <p class="pagination">
        共{{total}}条
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="20"
          @current-change="pageClick"
          class="pagina"
        ></el-pagination>
      </p>
    </div>
  </section>
</template>
<script>
import { post, get } from "@/axios/index";
import Paginations from '@/components/common/paginations'
export default {
  components: {
    Paginations
  },
  data() {
    return {
      brandList: [
        {brand:'美国Wealetc',name:'离心机',src:require('../../../assets/images/index/hc.png')},
        {brand:'美国Wealetc',name:'离心机',src:require('../../../assets/images/index/hc.png')},
        {brand:'美国Wealetc',name:'离心机',src:require('../../../assets/images/index/hc.png')},
        {brand:'美国Wealetc',name:'离心机',src:require('../../../assets/images/index/hc.png')},
        {brand:'美国Wealetc',name:'离心机',src:require('../../../assets/images/index/hc.png')},
        {brand:'美国Wealetc',name:'离心机',src:require('../../../assets/images/index/hc.png')},
        {brand:'美国Wealetc',name:'离心机',src:require('../../../assets/images/index/hc.png')},
        {brand:'美国Wealetc',name:'离心机',src:require('../../../assets/images/index/hc.png')},
        {brand:'美国Wealetc',name:'离心机',src:require('../../../assets/images/index/hc.png')},
        {brand:'美国Wealetc',name:'离心机',src:require('../../../assets/images/index/hc.png')},
        {brand:'美国Wealetc',name:'离心机',src:require('../../../assets/images/index/hc.png')},
      ],
      // totalPage: 0,
      brand:[],
      total: 0,
      page: 1,
      size: 15
    }
  },
  methods: {
    pageClick(index) {
      get("/stkbrandInfo/getaboutusinfo", {page: index, size: 15}).then(
        response => {
          this.brand = response.data.result.pageData;
          this.total = response.data.result.total;
        }
      );
    }
  },
   mounted() {
     this.pageClick()
   }
}
</script>
<style lang="less" scoped>
.wraper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .container {
    width: 1060px;
    margin: 0 auto;
    ul {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      border-bottom: 1px solid #ccc;
      li {
        // display: inline-block;
        width: 190px;
        height: 280px;
        margin: 5px 11px;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        img {
          width: 100%;
          height: 213px;
        }
        .bd {
          width: 100%;
          flex: 1;
          font-size: 12px;
          padding: 0 10px;
          p {
            width: 170px;
            line-height: 30px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
        // overflow: hidden;
        // margin: 10px 37px;
      }
    }
  }
}
.pagination {
  position: relative;
  width: 10%;
  height: 4%;
  top: 11%;
  left: 71%;
  padding: 4px;
  margin: 1%;
  .pagina {
    position: absolute;
    top: 0%;
    left: 58%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/agentBrand/index.vue